export async function adminFetch(path, options = {}) {
  const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, { credentials: "include", ...options });
  if (!r.ok) {
    const d = await r.json().catch(() => ({}));
    throw new Error(typeof d.detail === "string" ? d.detail : String(r.status));
  }
  return r.json();
}
